import { productAPI, masterAPI } from './api';
import Swal from 'sweetalert2';


export const productActions = {
     getCategories: async () => {
    try {
      const response = await productAPI.getCategories();
      console.log('Categories API response:', response);
      
      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch categories',
        data: []
      };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch categories',
        data: []
      };
    }
  },

  getBrands: async () => {
    try {
      const response = await productAPI.getBrands();
      console.log('Brands API response:', response);
      
      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch brands',
        data: []
      };
    } catch (error) {
      console.error('Error fetching brands:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch brands',
        data: []
      };
    }
  },

  getUnits: async () => {
    try {
      const response = await productAPI.getUnits();
      if (response && (response.success || response.data)) {
        return {
          success: true,
          data: response.data || response
        };
      }
      return {
        success: false,
        message: response?.message || 'Failed to fetch units',
        data: []
      };
    } catch (error) {
      console.error('Error fetching units:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch units',
        data: []
      };
    }
  },
    // Fetch all products
 fetchProducts: (params = {}) => {
    return async (dispatch) => {
        try {
            console.log('Fetching products with params:', params);
            
            const response = await productAPI.list(params);
            console.log('API Response:', response);
            
            if (response.success) {  // Note: Changed from response.status
                console.log('Products fetched:', response.data.products?.length || 0);
                console.log('Pagination info:', response.data.pagination);
                
                dispatch({
                    type: "Product_list",
                    payload: response.data.products || []
                });
                
                return {
                    success: true,
                    data: response.data,
                    pagination: response.data.pagination
                };
            } else {
                console.error('API returned false status:', response.message);
                throw new Error(response.message || 'Failed to fetch products');
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            
            if (!params.silent) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Failed to fetch products',
                    confirmButtonColor: '#ff0000'
                });
            }
            
            return {
                success: false,
                message: error.message || 'Failed to fetch products'
            };
        }
    };
},
    
   // Fetch single product by ID
    fetchProductById: (id) => {
        return async (dispatch) => {
            try {
                const response = await productAPI.getSingle(id);
                
                if (response.success) {
                    dispatch({
                        type: "Selected_Product",
                        payload: response.data
                    });
                    
                    return {
                        success: true,
                        data: response
                    };
                } else {
                    throw new Error(response.message || 'Failed to fetch product');
                }
            } catch (error) {
                console.error('Error fetching product by ID:', error);
                
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Failed to fetch product details',
                    confirmButtonColor: '#ff0000'
                });
                
                return {
                    success: false,
                    message: error.message || 'Failed to fetch product'
                };
            }
        };
    },

    // Add new product
    addProductList: (productData) => {
        return async () => {
            try {
                const response = await productAPI.create(productData);
                
                if (response.success) {
                    return {
                        success: true,
                        data: response.data,
                        message: response.message || 'Product added successfully'
                    };
                } else {
                    throw new Error(response.message || 'Failed to add product');
                }
            } catch (error) {
                console.error('Error adding product:', error);
                
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Failed to add product',
                    confirmButtonColor: '#ff0000'
                });
                
                return {
                    success: false,
                    message: error.message || 'Failed to add product'
                };
            }
        };
    },

    // In productActions.js - update updateProduct action
updateProduct: (id, productData) => {
    return async (dispatch) => {
        try {
            const response = await productAPI.update(id, productData);
            
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Product updated successfully',
                    confirmButtonColor: '#00ff00'
                });
                
                // Refresh product list (like brandActions)
                dispatch(productActions.fetchProducts());
                
                return {
                    success: true,
                    data: response.data
                };
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            console.error('Error updating product:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: error.message || 'Failed to update product',
                confirmButtonColor: '#ff0000'
            });
            return {
                success: false,
                message: error.message || 'Failed to update product'
            };
        }
    };
},
    // Delete product
    deleteProduct: (id) => {
        return async (dispatch) => {
            try {
                const response = await productAPI.delete(id);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Product deleted successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh product list
                    dispatch(productActions.fetchProducts());
                    
                       return {
                           success: true
                       };
                   } else {
                       throw new Error(response.message);
                   }
               } catch (error) {
                   console.error('Error deleting product:', error);
                   Swal.fire({
                       icon: 'error',
                       title: 'Error!',
                       text: error.message || 'Failed to delete product',
                       confirmButtonColor: '#ff0000'
                   });
                   return {
                       success: false,
                       message: error.message || 'Failed to delete product'
                   };
               }
           };
       },
    
    // Check SKU exists
    checkSkuExists: async (sku) => {
        try {
            const response = await productAPI.checkSku(sku);
            
            if (response.status) {
                return response.data.products && response.data.products.length > 0;
            }
            return false;
        } catch (error) {
            console.error('Error checking SKU:', error);
            return false;
        }
    },
    
    // Check item code exists
    checkItemCodeExists: async (itemCode) => {
        try {
            const response = await productAPI.checkItemCode(itemCode);
            
            if (response.status) {
                return response.data.products && response.data.products.length > 0;
            }
            return false;
        } catch (error) {
            console.error('Error checking item code:', error);
            return false;
        }
    },
    
    // Get master data
    getMasterData: () => {
        return async () => {
            try {
                const [categories, brands, units] = await Promise.all([
                    masterAPI.getCategories(),
                    masterAPI.getBrands(),
                    masterAPI.getUnits()
                ]);
                debugger;
                return {
                    success: true,
                    data: {
                        categories: categories.status ? categories.data.categories : [],
                        brands: brands.status ? brands.data : [],
                        units: units.status ? units.data.units : []
                    }
                };
            } catch (error) {
                console.error('Error fetching master data:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch master data'
                };
            }
        };
    },
    
    // Clear product details (for cleanup)
    clearProductDetails: () => {
        return {
            type: "CLEAR_PRODUCT_DETAILS"
        };
    }
};
